/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Use_4_ValueInputs */

const en_svc_rag_use_4_value = /** @type {(inputs: Svc_Rag_Use_4_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contracts, manuals and reports searched and summarised, with the passage each point came from.`)
};

const lv_svc_rag_use_4_value = /** @type {(inputs: Svc_Rag_Use_4_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Līgumi, rokasgrāmatas un atskaites ir meklējami un apkopoti, norādot fragmentu, no kura nāk katrs punkts.`)
};

/**
* | output |
* | --- |
* | "Contracts, manuals and reports searched and summarised, with the passage each point came from." |
*
* @param {Svc_Rag_Use_4_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_use_4_value = /** @type {((inputs?: Svc_Rag_Use_4_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Use_4_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_use_4_value(inputs)
	return en_svc_rag_use_4_value(inputs)
});